import React, { useMemo, useState } from 'react';
import { useAtomValue } from 'jotai';

import { Button, EmptyState, FileDropzone, Modal, useIsAdmin, useValidator } from 'components';
import { notifyApiError } from 'components/layout/Toasts';

import { ServicesApi } from 'src/api';
import { selectedCompanyAtom } from 'src/features/Services';

import AttachmentThumbnail from '../AttachmentThumbnail';

import style from './ServiceAttachments.module.scss';

const ServiceAttachments = ({ serviceId, files = [], refreshCallback, visible, setVisible }) => {
  const selectedCompany = useAtomValue(selectedCompanyAtom);
  const isAdmin = useIsAdmin();

  const [isFileUploading, setIsFileUploading] = useState(false);
  const [file, setFile] = useState(null);
  const validator = useValidator();

  const label = useMemo(() => {
    if (files.length === 0) {
      return 'Brak';
    } else if (files.length === 1) {
      return files[0].file_name;
    } else {
      return `${files[0].file_name} + ${files.length - 1} więcej...`;
    }
  }, [files]);

  const uploadAttachment = async () => {
    if (!validator.allValid()) {
      return validator.showMessages();
    }

    const queryParams = {
      service_id: serviceId,
      file,
      ...(isAdmin && { company_id: Number(selectedCompany) })
    };

    try {
      setIsFileUploading(true);
      await ServicesApi.uploadServiceFile(queryParams);
      setFile(null);
      validator.purgeFields();
      if (refreshCallback) refreshCallback();
    } catch (err) {
      notifyApiError(err);
    } finally {
      setIsFileUploading(false);
    }
  };

  return (
    <>
      <a onClick={() => setVisible(true)}>{label}</a>
      <Modal
        visible={visible}
        onClose={() => setVisible(false)}
        title={'Dodaj załącznik'}
      >
        <div className={style.container}>
          <div className={style.box}>
            <FileDropzone
              onChange={setFile}
              value={file}
              id={'file'}
              name={'file'}
              validator={validator}
              rule={'required'}
            />
            <Button
              label={'Dodaj załącznik'}
              onClick={uploadAttachment}
              isLoading={isFileUploading}
            />
          </div>
          <h3>Lista załączników</h3>
          {files.map((file) => (
            <AttachmentThumbnail
              key={file.id}
              serviceId={serviceId}
              refreshCallback={refreshCallback}
              {...file}
            />
          ))}
          {files.length === 0 && (
            <EmptyState
              tiny
              type={'servicesAttachments'}
            />
          )}
        </div>
      </Modal>
    </>
  );
};

export default ServiceAttachments;
